# import MemberFragment from "../fragments/member.graphql"

mutation UpdateMember($input: UpdateMemberInput!) {
  updateMember(input: $input) {
    ...MemberFragment
  }
}
